import uiRouter from 'angular-ui-router';
import {farelistDirective} from './farelist.directive';
import {farelistStore} from './farelist.store';

export const farelist = angular.module('farelist', [uiRouter])
  .config(($stateProvider) => {
    $stateProvider.state('app.farelist', {
      url: '/farelist.aspx',
      template: '<farelist></farelist>',
        params: {
          request: null
        }
    });
  })
  .directive('farelist', farelistDirective)
  .factory('farelistStore', farelistStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/farelist/farelist.js
 **/